import script from "./TwoButtonPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoButtonPopup.vue?vue&type=script&setup=true&lang=js"

import "./TwoButtonPopup.vue?vue&type=style&index=0&id=e5972f4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5972f4c"]])

export default __exports__